import { render, staticRenderFns } from "./StatisticsLayout.vue?vue&type=template&id=fc880974&scoped=true"
import script from "./StatisticsLayout.vue?vue&type=script&lang=js"
export * from "./StatisticsLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc880974",
  null
  
)

export default component.exports